import React, { Component } from "react";
import ZrCard from "@ali/zr-renderer";
import classnames from "classnames";

class Offer extends Component {
  constructor(opts) {
    super(opts);
    this.renderPrice = this.renderPrice.bind(this);
    this.renderMkc = this.renderMkc.bind(this);
    this.renderZkPrice = this.renderZkPrice.bind(this);
    this.renderTags = this.renderTags.bind(this);
  }

  renderTags() {
    const arr = [];
    let i = 0;
    const max = 3;
    const { data } = this.props;
    if (
      data.attr.marketOfferTag &&
      data.attr.marketOfferTag.newUserFirstFreePost &&
      data.attr.marketOfferTag.newUserFirstFreePost.enable
    ) {
      i++;
      if (i <= max) {
        arr.push(<div className="sdby">首单包邮</div>);
      }
    } else if (
      data.attr.tradePrice &&
      data.attr.tradePrice.freightPrice &&
      data.attr.tradePrice.freightPrice.free
    ) {
      i++;
      if (i <= max) {
        arr.push(<div className="sdby">包邮</div>);
      }
    }
    if (data.attr.offerSource && data.attr.offerSource.fromDaixiao) {
      i++;
      if (i <= max) {
        arr.push(<div className="sdby">一件代发</div>);
      }
    }

    if (data.attr.offerSource && data.attr.offerSource.fromSheZhang) {
      i++;
      if (i <= max) {
        arr.push(<div className="sdby">免费赊账</div>);
      }
    }

    if (
      data.attr.tradeService &&
      data.attr.tradeService.materialQualityEnsure
    ) {
      i++;
      if (i <= max) {
        arr.push(<div className="sdby">材质保障</div>);
      }
    }
    if (data.attr.tradeService && data.attr.tradeService.deliveryHours) {
      i++;
      if (i <= max) {
        arr.push(
          <div className="sdby">
            {data.attr.tradeService.deliveryHours}小时发货
          </div>
        );
      }
    } else if (
      data.attr.tradeService &&
      data.attr.tradeService.deliveryTimeEnsure
    ) {
      i++;
      if (i <= max) {
        arr.push(
          <div className="sdby">
            {data.attr.tradeService.deliveryTimeEnsure}交期保障
          </div>
        );
      }
    }

    if (data.attr.tradeService && data.attr.tradeService.replaceEnsureDays) {
      i++;
      if (i <= max) {
        arr.push(
          <div className="sdby">
            {data.attr.tradeService.replaceEnsureDays}天包换
          </div>
        );
      }
    }
    return arr.map((it) => it);
  }
  renderZkPrice() {
    let { discountPrice } = this.props.data;
    discountPrice = discountPrice || {};
    const { zkCat, zkPrice } = discountPrice;

    if (zkCat === "hp" && !!zkPrice) {
      return (
        <img
          className="ml5"
          src="https://img.alicdn.com/tfs/TB1H54yxljTBKNjSZFuXXb0HFXa-57-20.png"
          style={{ width: "57px", height: "20px" }}
        />
      );
    }
    if (!!zkPrice && zkCat !== "hp") {
      return (
        <img
          className="ml5"
          src="https://img.alicdn.com/tfs/TB1H7dAxb3nBKNjSZFMXXaUSFXa-57-20.png"
          style={{ width: "57px", height: "20px" }}
        />
      );
    } else {
      return <div />;
    }
  }
  //渲染阶梯价格
  renderPrice() {
    const { data } = this.props;
    let { discountPrice } = data;
    discountPrice = discountPrice || {};
    let { zkPrice } = discountPrice;
    const { price } = discountPrice;
    let { strPriceMoney } = data;
    let inter = strPriceMoney.substring(0, strPriceMoney.indexOf("."));
    let decimal = strPriceMoney.substring(strPriceMoney.indexOf("."));
    let _html = "";
    try {
      if (zkPrice) {
        strPriceMoney = price;
        zkPrice = `${zkPrice}`;
        const idx = zkPrice.indexOf(".");
        if (idx !== -1) {
          inter = zkPrice.substring(0, idx);
          decimal = zkPrice.substring(idx);
        } else {
          inter = zkPrice;
          decimal = "";
        }
        _html = (
          <a
            href={data.eurl}
            target="_blank"
            className="mt8 inline_block ml10"
            rel="noreferrer"
          >
            <span className="price">
              <i>
                <strong>¥</strong>
              </i>
              {inter}
              <span className="f12">{decimal}</span>
              <span className="orginPrice">¥{strPriceMoney}</span>
            </span>
          </a>
        );
      } else {
        _html = (
          <a
            href={data.eurl}
            target="_blank"
            className="mt8 inline_block ml10"
            rel="noreferrer"
          >
            <span className="price">
              <i>
                <strong>¥</strong>
              </i>
              {inter}
              <span className="f12">{decimal}</span>
            </span>
          </a>
        );
      }
    } catch (error) {
      _html = (
        <a
          href={data.eurl}
          target="_blank"
          className="mt8 inline_block ml10"
          rel="noreferrer"
        >
          <span className="price">
            <i>
              <strong>¥</strong>
            </i>
            {inter}
            <span className="f12">{decimal}</span>
          </span>
        </a>
      );
    }
    return _html;
  }

  renderMkc(mkc) {
    if (mkc) {
      //判断是会否包邮
      const { freePostage, amountAt, decreaseMoney, discountRate } = mkc;
      let count = 0;
      if (freePostage) {
        count++;
      }
      if (!!amountAt && !!decreaseMoney) {
        count++;
      }
      if (!!discountRate && count < 2) {
        count++;
      }
      if (count === 1) {
        if (freePostage && !!amountAt) {
          return (
            <div>
              <div className="tips" />
              <div className="tips2">满{amountAt / 100}包邮</div>
            </div>
          );
        } else if (!!amountAt && !!decreaseMoney) {
          //man 减
          return (
            <div>
              <div className="tips" />
              <div className="tips2">
                满{amountAt / 100}减{decreaseMoney / 100}
              </div>
            </div>
          );
        } else if (!!discountRate && !!amountAt) {
          //满打折
          return (
            <div>
              <div className="tips" />
              <div className="tips2">
                满{amountAt / 100}打{discountRate / 100}折
              </div>
            </div>
          );
        }
      } else if (count === 2) {
        //包邮 & 满减
        if (freePostage && !!amountAt && !!decreaseMoney) {
          return (
            <div>
              <div className="tips_two">
                <div className="wap">
                  <div className="tips_two_span" />
                  <div className="tips_two_span" />
                </div>
              </div>
              <div className="tips_two tips_two_txt">
                <div className="wap">
                  <div className="tips_two_span">
                    满{amountAt / 100}减{decreaseMoney / 100}
                  </div>
                  <div className="tips_two_span">满{amountAt / 100}包邮</div>
                </div>
              </div>
            </div>
          );
        } else if (freePostage && !!amountAt && !!discountRate) {
          return (
            <div>
              <div className="tips_two">
                <div className="wap">
                  <div className="tips_two_span" />
                  <div className="tips_two_span" />
                </div>
              </div>
              <div className="tips_two tips_two_txt">
                <div className="wap">
                  <div className="tips_two_span">
                    满{amountAt / 100}打{discountRate / 100}折
                  </div>
                  <div className="tips_two_span">满{amountAt / 100}包邮</div>
                </div>
              </div>
            </div>
          );
        } else if (
          !!amountAt &&
          !!decreaseMoney &&
          !!amountAt &&
          !!discountRate
        ) {
          return (
            <div>
              <div className="tips_two">
                <div className="wap">
                  <div className="tips_two_span" />
                  <div className="tips_two_span" />
                </div>
              </div>
              <div className="tips_two tips_two_txt">
                <div className="wap">
                  <div className="tips_two_span">
                    满{amountAt / 100}减{decreaseMoney / 100}
                  </div>
                  <div className="tips_two_span">
                    满{amountAt / 100}打{discountRate / 100}折
                  </div>
                </div>
              </div>
            </div>
          );
        }
      }
    }
  }
  render() {
    const { data, mkc, index } = this.props;
    let cbu_ad_sessionid = '';
    let cbu_ad_adgroup_id = '';
    //兼容垃圾数据
    if (!data.attr.tradePrice) {
      return <div />;
    }

    const isp4p = data.p4P || data.isP4P ? 1 : 0;

    let { imgUrl } = data;
    if (imgUrl.indexOf("cbu01.alicdn.com") > -1) {
      imgUrl = `${imgUrl}?_=2020`;
    }

    const zrStyle = {
      position: "relative",
      marginRight: "11px",
      marginBottom: "11px",
    };

    //data.isPcSem = true;
    //delete data.loginId;
    //添加打点参数
    let {trackInfo} = data;
    if(trackInfo && typeof trackInfo === 'string') {
      trackInfo = JSON.parse(trackInfo);
    } else if(!trackInfo) {
      trackInfo = {};
    }

    cbu_ad_sessionid = trackInfo.cbu_ad_sessionid;
    cbu_ad_adgroup_id = trackInfo.cbu_ad_adgroup_id;

    return (
      <div
        className={classnames({
          offer_exp: data.impressionEurl,
        })}
        data-jplus-exp-url={`${data.impressionEurl}&idx=${index}`}
        data-tracker="offer"
        data-aplus-report={`object_type@offer^object_id@${data.offerid}^_p_isad@${isp4p}^cbu_ad_sessionid@${cbu_ad_sessionid}^cbu_ad_adgroup_id@${cbu_ad_adgroup_id}`}
        style={zrStyle}
      >
        <ZrCard {...data} />
      </div>
    );
  }
}

export default Offer;
